"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Text = _interopRequireDefault(require("../Text"));
var _BottomSheet = _interopRequireDefault(require("../BottomSheet"));
var _constant = require("../constant");
var _tripType = _interopRequireDefault(require("./tripType.proptypes"));
var _constant2 = require("./constant");
var _TripTypes = _interopRequireDefault(require("./TripTypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TripTypeSelectWrapper = _styledComponents.default.div.withConfig({
  displayName: "TripTypeSelector__TripTypeSelectWrapper",
  componentId: "sc-ek8iia-0"
})(["position:relative;cursor:pointer;-webkit-tap-highlight-color:transparent;"]);
var DesktopModal = _styledComponents.default.div.withConfig({
  displayName: "TripTypeSelector__DesktopModal",
  componentId: "sc-ek8iia-1"
})(["display:", ";position:absolute;width:184px;background-color:", ";border:1px solid ", ";border-radius:", ";z-index:1;"], function (_ref) {
  var display = _ref.display;
  return display;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.backgroundColor.default;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.greyLight;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius.small;
});
var TripTypeSelectInputWrapper = _styledComponents.default.div.withConfig({
  displayName: "TripTypeSelector__TripTypeSelectInputWrapper",
  componentId: "sc-ek8iia-2"
})(["display:flex;align-items:center;min-height:56px;"]);
var InputLabelContainer = _styledComponents.default.div.withConfig({
  displayName: "TripTypeSelector__InputLabelContainer",
  componentId: "sc-ek8iia-3"
})([""]);
var TripTypeSelector = function TripTypeSelector(props) {
  var elements = [];
  var selectItemRef = _react.default.useRef();
  var data = props.data,
    viewType = props.viewType,
    theme = props.theme,
    tripTypeOutput = props.tripTypeOutput,
    mobileHeaderLabel = props.mobileHeaderLabel,
    prefillTripTypeCode = props.prefillTripTypeCode;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    openModal = _useState2[0],
    setOpenModal = _useState2[1];
  var _useState3 = (0, _react.useState)(data[0].label),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    tripTypeLabel = _useState4[0],
    settripTypeLabel = _useState4[1];
  var _useState5 = (0, _react.useState)(data[0].code),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    selectedCode = _useState6[0],
    setselectedCode = _useState6[1];
  var _React$useState = _react.default.useState(_constant2.HoverSource.KeyBoard),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    hoverSource = _React$useState2[0],
    setHoverSource = _React$useState2[1];
  var getTripTypeIndex = function getTripTypeIndex(tripCode, element) {
    return element.find(function (_ref5) {
      var tripData = _ref5.tripData;
      return tripData.code === tripCode;
    });
  };
  var tripTypeIndex = prefillTripTypeCode ? elements.indexOf(getTripTypeIndex(prefillTripTypeCode, elements)) : -1;
  var _React$useState3 = _react.default.useState(tripTypeIndex),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    tripIndex = _React$useState4[0],
    setTripIndex = _React$useState4[1];
  /* ------ close tripType selection modal on clicking outside ----- */
  var wrapperRef = (0, _react.useRef)(null);
  var handleClickOutside = function handleClickOutside() {
    setOpenModal(false);
  };
  _utilities.default.useOutsideClickHandler(wrapperRef, handleClickOutside);
  /* ------------------------------------------------------------------ */

  var onSelectionDone = function onSelectionDone(label, code, type, url, event) {
    // only accept enter key/ click as selection. prevent tab key from selecting.
    if (type === _constant2.REDIRECT && (event === 'Enter' || event === 'Click')) {
      setOpenModal(!openModal);
      window.open(url);
    } else if (event === 'Enter' || event === 'Click') {
      settripTypeLabel(label);
      setselectedCode(code);
      setOpenModal(!openModal);
      if (tripTypeOutput) tripTypeOutput(code);
    }
  };
  var scrollToRef = function scrollToRef(itemList, newTop) {
    if (itemList && itemList.scrollTo) {
      itemList.scrollTo({
        behavior: 'smooth',
        top: newTop
      });
    }
  };
  var processScrollToItem = function processScrollToItem(itemListRef, highlightedItemIndex) {
    var itemList = itemListRef.current;
    if (itemList) {
      var maxItemsLength = Math.ceil(_constant2.MAX_HEIGHT / (_constant2.SCROLL_SPACE + 2));
      var rangeItems = highlightedItemIndex - maxItemsLength;
      var fromTopPos = itemList.scrollTop;
      var toTopPos = fromTopPos + _constant2.MAX_HEIGHT - _constant2.SCROLL_SPACE;
      var currentTopPos = highlightedItemIndex * _constant2.SCROLL_SPACE;
      var supportToScroll = !(currentTopPos < toTopPos && currentTopPos > fromTopPos);
      if (supportToScroll) {
        var newTop = (currentTopPos > fromTopPos ? rangeItems + 1 : highlightedItemIndex) * _constant2.SCROLL_SPACE;
        scrollToRef(itemList, newTop);
      }
    }
  };
  _react.default.useEffect(function () {
    if (selectItemRef.current) {
      selectItemRef.current.focus();
      if (openModal) {
        processScrollToItem(selectItemRef, tripTypeIndex);
      }
    }
  });
  var handleMouseMove = function handleMouseMove(newItemIndex) {
    return function (event) {
      event.preventDefault();
      setTripIndex(newItemIndex);
      setHoverSource(_constant2.HoverSource.MouseOver);
    };
  };
  var renderTripTypeSelection = function renderTripTypeSelection() {
    var dataWithIds = data.map(function (item) {
      var id = '';
      if (item.label === 'Round-trip') {
        id = 'home_roundtrip';
      } else if (item.label === 'One-way') {
        id = 'home_oneway';
      } else {
        id = 'home_multiicity';
      }
      return _objectSpread(_objectSpread({}, item), {}, {
        id: id
      });
    });
    for (var i = 0; i < data.length; i += 1) {
      elements.push( /*#__PURE__*/_react.default.createElement(_TripTypes.default, {
        id: dataWithIds[i].id,
        key: i,
        code: dataWithIds[i].code,
        label: dataWithIds[i].label,
        type: dataWithIds[i].selectionType,
        url: dataWithIds[i].url,
        onSelectionDone: onSelectionDone,
        displaySelected: selectedCode,
        onMouseMove: handleMouseMove(i),
        isHovered: tripIndex === i,
        hoverSource: hoverSource,
        accessible: true
      }));
    }
    return elements;
  };
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var handleClick = function handleClick() {
    setOpenModal(!openModal);
  };
  var handleKeyDown = function handleKeyDown(event) {
    setHoverSource(_constant2.HoverSource.KeyBoard);
    switch (event.key) {
      case 'ArrowDown':
        {
          event.preventDefault();
          if (tripIndex < elements.length - 1) {
            setTripIndex(tripIndex + 1);
          }
          break;
        }
      case 'ArrowUp':
        {
          event.preventDefault();
          if (tripIndex > 0) {
            setTripIndex(tripIndex - 1);
          }
          break;
        }
      case 'Enter':
        {
          event.preventDefault();
          handleClick();
          onSelectionDone(elements[tripIndex].props.label, elements[tripIndex].props.code, elements[tripIndex].props.type, elements[tripIndex].props.url, 'Enter');
          break;
        }
      case 'Tab':
        {
          handleClickOutside();
          break;
        }
      case 'Shift':
        {
          break;
        }
      default:
        // WIP
        break;
    }
  };
  (0, _react.useEffect)(function () {
    if (!prefillTripTypeCode) {
      tripTypeOutput(selectedCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    if (prefillTripTypeCode) {
      var prefillLabel = data.filter(function (trips) {
        return trips.code === prefillTripTypeCode;
      });
      if (prefillLabel[0] && prefillLabel[0].label) {
        settripTypeLabel(prefillLabel[0].label);
        setselectedCode(prefillTripTypeCode);
        tripTypeOutput(prefillTripTypeCode);
      } else {
        tripTypeOutput(selectedCode);
      }
    }
  }, [prefillTripTypeCode]);
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(TripTypeSelectWrapper, {
      id: "home_triptype",
      ref: wrapperRef,
      onClick: handleClick,
      onKeyDown: handleKeyDown,
      tabIndex: 0,
      accessible: true
    }, /*#__PURE__*/_react.default.createElement(TripTypeSelectInputWrapper, {
      openModal: openModal
    }, /*#__PURE__*/_react.default.createElement(InputLabelContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      display: "inlineFlex",
      theme: theme,
      type: _constant2.DEFAULT_STYLE.PLACEHOLDER.TYPE,
      accessible: false
    }, tripTypeLabel)), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: _constant2.DEFAULT_STYLE.DROPDOWN_ICON.COLOR,
      fontsize: _constant2.DEFAULT_STYLE.DROPDOWN_ICON.FONT_SIZE,
      icon: _constant2.DEFAULT_STYLE.DROPDOWN_ICON.ICON,
      theme: theme,
      accessible: false
    })), viewType === _constant.DEVICE_TYPE.MOBILE ? /*#__PURE__*/_react.default.createElement(_BottomSheet.default, {
      height: "40%",
      show: openModal,
      theme: theme,
      headerTitle: mobileHeaderLabel,
      showCloseBtn: true,
      showOverlay: true
    }, renderTripTypeSelection()) : /*#__PURE__*/_react.default.createElement(DesktopModal, {
      tabIndex: 0,
      display: openModal ? 'block' : 'none'
    }, renderTripTypeSelection()));
  };
  getMain.propTypes = _tripType.default.PropTypes;
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
TripTypeSelector.propTypes = _tripType.default.PropTypes;
TripTypeSelector.defaultProps = _tripType.default.DefaultProps;
var _default = TripTypeSelector;
exports.default = _default;